import React, { useMemo } from 'react';
import { TimeSlot, TimeSlotsByDuration } from './BookingView';
import { useTranslation } from 'react-i18next';
import { he, enUS } from 'date-fns/locale';
import { format } from 'date-fns';
import { AppointmentType } from '../../types/AppointmentType';
import SelectCustom from '../select-custom/SelectCustom';


interface Props {
  selectedDate: Date;
  timeSlots: TimeSlotsByDuration;
  appointmentTypes: AppointmentType[];
  selectedType: AppointmentType | null;
  selectedTime: string | null;
  onTypeSelect: (type: AppointmentType) => void;
  onTimeSelect: (time: string) => void;
  onContinue: () => void;
}

const TimeByTypeView: React.FC<Props> = ({
  selectedDate,
  timeSlots,
  appointmentTypes,
  selectedType,
  selectedTime,
  onTypeSelect,
  onTimeSelect,
  onContinue,
}) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'he' ? he : enUS;


  const appointmentTypeOptions = appointmentTypes.map((type) => ({
    label: `${type.name}${type.durationMinutes != null ? ` (${type.durationMinutes} ${t('min')})` : ''}`,
    //value: type._id ?? type.name,
    value: type.name,
  }));

  //const selectedValue = selectedType?._id ?? selectedType?.name ?? '';
  const selectedValue = selectedType?.name ?? '';

  return (
    <div className="p-4">
      <h5>{t('select-appointment-type')}</h5>

      <div className="mb-3">
        <SelectCustom
          options={appointmentTypeOptions}
          selectedValue={selectedValue}
          onChange={(value) => {
            const selected = appointmentTypes.find(
              //(t) => t._id === value || t.name === value
              (t) => t.name === value
            );
            if (selected) onTypeSelect(selected);
          }}
          width="100%" // or "6rem" if that’s your preferred width
        />
      </div>

      {selectedType && selectedType.durationMinutes != null && (
        <>
          <h6>
            {t('available-times-for')} {format(selectedDate, 'EEEE, d MMMM yyyy', { locale })}
          </h6>
          <div className="d-flex flex-wrap gap-2 mb-3 mt-3">
            {(timeSlots[selectedType.durationMinutes] || []).map(slot => (
              <button
                key={slot.time}
                className={`btn ${slot.available ? 'btn-outline-primary' : 'btn-outline-secondary'} ${selectedTime === slot.time ? 'active' : ''}`}
                disabled={!slot.available}
                onClick={() => onTimeSelect(slot.time)}
              >
                {slot.time}
              </button>
            ))}
          </div>
        </>
      )}

      <button
        className="btn btn-primary float-end mb-3"
        disabled={!selectedType || !selectedTime}
        onClick={onContinue}
      >
        {t('continue')}
      </button>
    </div>
  );
};

export default TimeByTypeView;
